import React, { useEffect, useState } from "react";
import { Marker, InfoWindow } from "@react-google-maps/api";
import { AQIDataItem, NoiseDataItem } from "../utils/types";
import AQIProgressModal from "./AqiProgressGraph";
import { getNoiseLevelColorCode } from "../utils/getNoiseLevelColorCode";
import { parse } from "path";

interface MarkerViewProps {
  data: NoiseDataItem;
  index: number;
  noAnimation?: boolean;
}

export const NoiseMarkerView: React.FC<MarkerViewProps> = ({
  data,
  index,
  noAnimation,
}) => {
  const [showInfo, setShowInfo] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowInfo(false), 10000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Marker
      position={{ lat: Number(data.lat), lng: Number(data.long) }}
      onClick={() => setShowInfo(true)}
      label={data.value.toString()}
      icon={{
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: "#9DE1FE",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 4,
        scale: 18,
      }}
    >
      {showInfo && (
        <InfoWindow
          onCloseClick={() => setShowInfo(false)}
          options={{ headerDisabled: true }}
        >
          <div className=" bg-white">
            <button
              onClick={() => setShowInfo(false)}
              className="text-gray-500 hover:text-gray-700 focus:outline-none text-base absolute top-0 right-1"
              aria-label="Close Info Window"
            >
              ✖
            </button>
            <div className="flex items-center justify-between flex-col px-2">
              <p className="font-semibold text-base  ">{data.header}</p>
              <p className="font-semibold text-sm  text-gray-500">
                {data.zone}
              </p>
              <div className="flex items-center gap-2 pt-1">
                <p
                  className="font-semibold text-lg "
                  style={{
                    color: getNoiseLevelColorCode(
                      parseInt(data.value),
                      data.zone
                    ),
                  }}
                >
                  {data.value}
                </p>
                <p className="font-semibold text-base ">dB(A)</p>
              </div>
              <p className="font-semibold text-sm  text-gray-500">
                {data?.date}
              </p>
            </div>
            {/* <AQIProgressModal data={data} /> */}
          </div>
        </InfoWindow>
      )}
    </Marker>
  );
};
